"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponsiveImage = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Image_1 = require("../Image");
var AspectRatioBox_1 = require("../AspectRatioBox");
var Spinner_1 = require("../Spinner");
var Themer_1 = require("../Themer");
var Container = (0, styled_components_1.default)(AspectRatioBox_1.AspectRatioBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow: hidden;\n"], ["\n  overflow: hidden;\n"])));
var Loading = (0, styled_components_1.default)(Spinner_1.Spinner).attrs({ size: 16 })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  mix-blend-mode: difference;\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  mix-blend-mode: difference;\n"])));
var Placeholder = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  background-position: center center;\n  filter: blur(1em);\n  transform: scale(1.1);\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  background-position: center center;\n  filter: blur(1em);\n  transform: scale(1.1);\n"])));
var ResponsiveImage = function (_a) {
    var aspectWidth = _a.aspectWidth, aspectHeight = _a.aspectHeight, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight, backgroundColor = _a.backgroundColor, indicator = _a.indicator, placeholder = _a.placeholder, children = _a.children, rest = __rest(_a, ["aspectWidth", "aspectHeight", "maxWidth", "maxHeight", "backgroundColor", "indicator", "placeholder", "children"]);
    var _b = __read((0, react_1.useState)(false), 2), completed = _b[0], setCompleted = _b[1];
    var handleComplete = (0, react_1.useCallback)(function () { return setCompleted(true); }, []);
    var scheme = (0, Themer_1.useThemer)().scheme;
    return (react_1.default.createElement(Container, { position: "relative", aspectWidth: aspectWidth, aspectHeight: aspectHeight, maxWidth: maxWidth, maxHeight: maxHeight, backgroundColor: backgroundColor },
        react_1.default.createElement(Image_1.Image, __assign({ position: "relative", width: "100%", height: "100%", onComplete: handleComplete, zIndex: completed ? 1 : null }, rest)),
        placeholder && (react_1.default.createElement(Placeholder, { style: { backgroundImage: "url(".concat(placeholder, ")") } })),
        !completed && indicator && (react_1.default.createElement(Loading, { color: scheme === "light" ? "background" : "primary" })),
        children));
};
exports.ResponsiveImage = ResponsiveImage;
exports.ResponsiveImage.displayName = "ResponsiveImage";
exports.ResponsiveImage.defaultProps = {
    backgroundColor: "tertiary",
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=ResponsiveImage.js.map